<template>
    <div class="course" :class="[this.status ? 'enable' : 'disable']" @click="goCourse()">
        <div class="image-wrapper">
            <div class="image-bg" :style="{ backgroundImage: `url(${image})` }">
                <div class="degrade"></div>
            </div>
        </div>
        <div class="infos-below">
            <div class="progress_course">
                <div class="progress-container">
                    <div 
                        class="progress-bar" 
                        :style="{ width: ((this.data && this.data.progress != null) ? this.data.progress : 0) + '%' }"
                    ></div>
                </div>
                <span class="progress-label">
                    {{ formatNumber((this.data && this.data.progress != null) ? this.data.progress : 0) }}%
                </span>
            </div>
            <p class="course-title">{{ title }}</p>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {};
    },
    methods: {
        ...mapActions(['storeCurrentCoursePortal']),
        goCourse() {
            this.storeCurrentCoursePortal({ currentCoursePortal: this.data });
            window.location.href = `/aluno/curso/${this.id}`;
        },
        formatNumber(value) {
            if (typeof value === 'number') {
                return value.toFixed(0);
            } else {
                let parsed = parseFloat(value);
                return isNaN(parsed) ? 'Invalid Number' : parsed.toFixed(0);
            }
        }
    },
    props: {
        image: {
            type: String
        },
        title: {
            type: String
        },
        progress: {
            type: Number
        },
        id: {
            Number
        },
        status: {
            Boolean
        },
        data: {
            Array
        }
    }
}
</script>
<style scoped>
.dark .course p.course-title {
    color: white;
}

.course {
    display: flex;
    flex-direction: column;
    height: 320px;
    border-radius: 10px;
    /* box-shadow removido conforme solicitado */
    cursor: pointer;
    overflow: hidden;
    position: relative;
    transition: box-shadow 0.2s;
}

.image-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    min-height: 170px;
    max-height: 320px;
    overflow: hidden;
    border-radius: 10px 10px 0 0;
}

.image-bg {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
}

.degrade {
    background: rgb(0,0,0);
    background: linear-gradient(0deg, rgb(16 16 16) 0%, rgba(0,0,0,0.5858718487394958) 15%, rgba(0,212,255,0) 83%);
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px 10px 0 0;
    top: 0;
    left: 0;
    pointer-events: none;
}

.infos-below {
    width: 100%;
    background: transparent;
    padding: 18px 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1 1 auto;
    align-items: flex-start; /* Centraliza à esquerda */
}

.course-title {
    color: #242424;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    margin: 10px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left; /* Centraliza à esquerda */
    align-self: flex-start; /* Centraliza à esquerda */
    width: 100%;
}

.progress_course {
    align-items: center;
    display: flex;
    color: #b4b1ad;
    font-size: 12px;
    margin-top: 0;
    padding: 0!important;
    justify-content: flex-start; /* Centraliza à esquerda */
    width: 100%;
}

.progress-container {
    width: 100%;
    height: 10px;
    background-color: #e0e0e0;
    border-radius: 6px;
    margin: 0;
    position: relative;
    overflow: hidden;
    /* box-shadow removido conforme solicitado */
    flex: 1 1 auto;
}

.progress-bar {
    background: linear-gradient(90deg, #19c7d0 0%, #0e8a92 100%);
    height: 100%;
    border-radius: 6px 0 0 6px;
    transition: width 0.4s cubic-bezier(0.4,0,0.2,1);
    min-width: 6px;    
    position: absolute;
    top: 0;
    margin: 0;
}

.progress-label {
    margin-left: 10px;
    font-size: 13px;
    color: #19c7d0;
    font-weight: 600;
    letter-spacing: 0.5px;
    vertical-align: middle;
    white-space: nowrap;
}

@media (max-width: 768px) {
    .course {
        height: 263px;
    }
    .image-wrapper {
        min-height: 120px;
        height: 320px;
    }
    .infos-below {
        padding: 12px 10px 0 10px;
    }
    .course-title {
        font-size: 15px;
    }
}
</style>